import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { SkillsIdeateHttpClient } from './skills-ideate.http-client';
import { SkillsIdeateActions } from './skills-ideate.store';

@Injectable({ providedIn: 'root' })
export class SkillsIdeateEffects {
  private readonly actions$ = inject(Actions);
  private readonly http = inject(SkillsIdeateHttpClient);

  public effects = createEffectFactory(SkillsIdeateActions, this.actions$);

  public startIdeate$ = this.effects(SkillsIdeateActions.startIdeate, ({ payload }) =>
    this.http.startIdeate(payload).pipe(
      map(data => SkillsIdeateActions.startIdeateSuccess({ payload: { data } })),
      catchError((err: HttpErrorResponse) =>
        of(SkillsIdeateActions.startIdeateFailed({ payload: err.error })),
      ),
    ),
  );

  public fetchIdeate$ = this.effects(SkillsIdeateActions.fetchIdeate, ({ payload }) =>
    this.http.getIdeate(payload.id).pipe(
      map(data => SkillsIdeateActions.fetchIdeateSuccess({ payload: { data } })),
      catchError((err: HttpErrorResponse) =>
        of(SkillsIdeateActions.fetchIdeateFailed({ payload: err.error })),
      ),
    ),
  );
}
